import { render } from "./UserRichclePage.vue?vue&type=template&id=c2e63996&scoped=true&ts=true"
import script from "./userRichcle.component.ts?vue&type=script&lang=ts"
export * from "./userRichcle.component.ts?vue&type=script&lang=ts"

import "./userRichcle.scss?vue&type=style&index=0&id=c2e63996&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/e-wallet-fe/e-wallet-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e63996"]])

export default __exports__